import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Teleport as _Teleport } from "vue"
import _imports_0 from '../static/icons/country-switcher-selected-cart-icon.svg'
import _imports_1 from '../static/icons/country-switcher-cart-icon.svg'


const _hoisted_1 = {
  class: "country-select",
  "aria-labelledby": "country-selector-title"
}
const _hoisted_2 = {
  class: "country-select__caption",
  id: "country-selector-title"
}
const _hoisted_3 = { class: "country-select__form" }
const _hoisted_4 = { class: "country-select__selected" }
const _hoisted_5 = {
  key: 0,
  class: "country-select__selected-country-icon",
  src: _imports_0
}
const _hoisted_6 = { class: "country-select__selected-country" }
const _hoisted_7 = { class: "country-select__selected-currency" }
const _hoisted_8 = { class: "country-select__option" }
const _hoisted_9 = {
  key: 0,
  class: "country-select__option-country-icon",
  src: _imports_0
}
const _hoisted_10 = {
  key: 1,
  class: "country-select__option-country-icon",
  src: _imports_1
}
const _hoisted_11 = {
  key: 2,
  class: "country-select__no-country-icon"
}
const _hoisted_12 = { class: "country-select__option-country" }
const _hoisted_13 = { class: "country-select__option-currency" }
const _hoisted_14 = {
  key: 0,
  class: "country-select__no-delivery"
}
const _hoisted_15 = {
  key: 1,
  class: "country-select__payment-methods"
}
const _hoisted_16 = ["alt", "src"]
const _hoisted_17 = {
  key: 0,
  class: "country-select__error"
}

import {
  ref, inject, onMounted, onBeforeUnmount, computed, nextTick
} from 'vue';

import { toLitiumMediaUrlKey } from '@distancify/drapejs-litium/lib/keys';
import useContext from '@/composables/useContext';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import useCountrySwitch from '@/composables/useCountrySwitch';
import { registerModalKey, unregisterModalKey } from '@/composables/useModals';

import ModalContainer from './ModalContainer.vue';
import Dropdown from './forms/Dropdown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CountrySelect',
  setup(__props) {

const registerModal: any = inject(registerModalKey);
const unregisterModal: any = inject(unregisterModalKey);
const toLitiumMediaUrl: any = inject(toLitiumMediaUrlKey);

const { mitt } = useContext();
const { websiteText } = useWebsiteTexts();
const {
  availableCountries,
  buildRedirectUrl,
  countryOptions,
  activeCountryOption,
  setCountry,
  changeCountryError,
} = useCountrySwitch();

const isOpen = ref(false);
const countryId = ref('');
const transactionError = ref('');
const isMounted = ref(false);
const dropdownRef = ref(null);

const open = () => {
  isOpen.value = true;
  countryId.value = activeCountryOption.value?.countryId || '';
  registerModal('CountrySelect');
  nextTick(() => {
    dropdownRef.value.$el.focus();
  });
};

const close = () => {
  isOpen.value = false;
  unregisterModal('CountrySelect');
  mitt.emit('close-country-select');
};

const selectedChannel = computed(() => (availableCountries.value || []).find(
  (c) => c.countryId === countryId.value,
));

const supportsEcommerceFeatures = computed(
  () => selectedChannel.value?.supportsEcommerceFeatures || false,
);

const paymentMethodImages = computed(() => (selectedChannel.value?.paymentMethodImages || [])
  .map((e) => {
    const r = { ...e };
    r.url = toLitiumMediaUrl?.(r.id);
    return r;
  }));

const onSetCountryRequest = async () => {
  try {
    transactionError.value = '';
    const { error, redirectUrl } = await setCountry(countryId.value);

    if (error === 'NONE') {
      const url = buildRedirectUrl(redirectUrl);
      close();

      if (url) {
        window.location.assign(url);
      } else {
        window.location.reload();
      }
    } else {
      transactionError.value = changeCountryError.value;
    }
  } catch (err) {
    console.error(err);
    transactionError.value = changeCountryError.value;
  }
};

onMounted(() => {
  mitt.on('open-country-select', open);
  isMounted.value = true;
});

onBeforeUnmount(() => {
  mitt.off('open-country-select', open);
});

return (_ctx: any,_cache: any) => {
  return (isMounted.value)
    ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "body"
      }, [
        (isOpen.value)
          ? (_openBlock(), _createBlock(ModalContainer, {
              key: 0,
              onCloseModal: close,
              "show-exit-button": true,
              position: "center",
              class: "country-select__modal"
            }, {
              default: _withCtx(() => [
                _createElementVNode("aside", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(websiteText)('global__choose_country').value ||
              'global__choose_country'), 1),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(Dropdown, {
                      options: _unref(countryOptions),
                      modelValue: countryId.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((countryId).value = $event)),
                      class: "country-select__form-item",
                      ref_key: "dropdownRef",
                      ref: dropdownRef
                    }, {
                      selected: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_4, [
                          (slotProps.selected.supportsEcommerceFeatures)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_6, _toDisplayString(slotProps.selected.text), 1),
                          _createElementVNode("span", _hoisted_7, _toDisplayString(slotProps.selected.currencyId), 1)
                        ])
                      ]),
                      option: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_8, [
                          (
                      slotProps.option.supportsEcommerceFeatures &&
                      slotProps.isSelected
                    )
                            ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                            : _createCommentVNode("", true),
                          (
                      slotProps.option.supportsEcommerceFeatures &&
                      !slotProps.isSelected
                    )
                            ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                            : _createCommentVNode("", true),
                          (!slotProps.option.supportsEcommerceFeatures)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_12, _toDisplayString(slotProps.option.text), 1),
                          _createElementVNode("div", _hoisted_13, _toDisplayString(slotProps.option.currencyId), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["options", "modelValue"]),
                    (!_unref(supportsEcommerceFeatures))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(websiteText)('global__ecommerce_features_not_supported').value ||
                'global__ecommerce_features_not_supported'), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "primary-button country-select__submit",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (onSetCountryRequest()))
                    }, _toDisplayString(_unref(websiteText)('global__change_country_submit').value ||
                'global__change_country_submit'), 1),
                    (_unref(paymentMethodImages).length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paymentMethodImages), (paymentMethod, idx) => {
                            return (_openBlock(), _createElementBlock("img", {
                              key: idx,
                              alt: paymentMethod.alt,
                              src: paymentMethod.url
                            }, null, 8, _hoisted_16))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (transactionError.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(transactionError.value), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})